/* eslint-disable comma-dangle */
import BeautyPreferencesBeautyPreferences from 'pages/BeautyPreferences/BeautyPreferences';
import BrandsListBrands from 'pages/Brands/BrandsList';
import NewRwdBuyPageBuyPage from 'pages/BuyPage/NewRwdBuyPage';
import RwdBuyPageBuyPage from 'pages/BuyPage/RwdBuyPage';
import CheckoutCheckout from 'pages/Checkout/Checkout';
import ConfirmationCheckout from 'pages/Checkout/Confirmation';
import FSCheckoutCheckout from 'pages/Checkout/FSCheckout';
import RwdCheckoutCheckout from 'pages/Checkout/RwdCheckout';
import CommunityCommunity from 'pages/Community/Community';
import AddPhotoGallery from 'pages/Community/Gallery/AddPhoto';
import UsersPublicGalleryGallery from 'pages/Community/Gallery/UsersPublicGallery';
import GalleryPageCommunity from 'pages/Community/GalleryPage';
import MyGalleryCommunity from 'pages/Community/MyGallery';
import MyPointsBeautyInsider from 'pages/Community/RichProfile/BeautyInsider/MyPoints';
import BeautyInsiderRichProfile from 'pages/Community/RichProfile/BeautyInsider';
import CreditCardRichProfile from 'pages/Community/RichProfile/CreditCard';
import InstoreServicesRichProfile from 'pages/Community/RichProfile/InstoreServices';
import ListsRichProfile from 'pages/Community/RichProfile/Lists';
import AddressesMyAccount from 'pages/Community/RichProfile/MyAccount/Addresses';
import AutoReplenishmentMyAccount from 'pages/Community/RichProfile/MyAccount/AutoReplenishment';
import CurbsidePickupCheckinModalRouterCurbsidePickupCheckinModal from 'pages/Community/RichProfile/MyAccount/CurbsidePickupCheckinModal/CurbsidePickupCheckinModalRouter';
import VehicleColorSelectorCurbsidePickupCheckinModal from 'pages/Community/RichProfile/MyAccount/CurbsidePickupCheckinModal/VehicleColorSelector';
import CurbsideNotAvailableScreenscreens from 'pages/Community/RichProfile/MyAccount/CurbsidePickupCheckinModal/screens/CurbsideNotAvailableScreen';
import CurbsidePickupBarcodeScreenscreens from 'pages/Community/RichProfile/MyAccount/CurbsidePickupCheckinModal/screens/CurbsidePickupBarcodeScreen';
import CurbsidePickupCheckinScreenscreens from 'pages/Community/RichProfile/MyAccount/CurbsidePickupCheckinModal/screens/CurbsidePickupCheckinScreen';
import CurbsidePickupLandingScreenscreens from 'pages/Community/RichProfile/MyAccount/CurbsidePickupCheckinModal/screens/CurbsidePickupLandingScreen';
import CurbsidePickupStoreClosedScreenscreens from 'pages/Community/RichProfile/MyAccount/CurbsidePickupCheckinModal/screens/CurbsidePickupStoreClosedScreen';
import EmailPostalMyAccount from 'pages/Community/RichProfile/MyAccount/EmailPostal';
import OrderDetailsMyAccount from 'pages/Community/RichProfile/MyAccount/OrderDetails';
import OrdersMyAccount from 'pages/Community/RichProfile/MyAccount/Orders';
import PaymentMethodsMyAccount from 'pages/Community/RichProfile/MyAccount/PaymentMethods';
import ReplacementOrderMyAccount from 'pages/Community/RichProfile/MyAccount/ReplacementOrder';
import ReplacementOrderStatusMyAccount from 'pages/Community/RichProfile/MyAccount/ReplacementOrderStatus';
import ResetPasswordMyAccount from 'pages/Community/RichProfile/MyAccount/ResetPassword';
import SameDayUnlimitedMyAccount from 'pages/Community/RichProfile/MyAccount/SameDayUnlimited';
import TaxClaimMyAccount from 'pages/Community/RichProfile/MyAccount/TaxClaim';
import MyAccountRichProfile from 'pages/Community/RichProfile/MyAccount';
import MyCustomListRichProfile from 'pages/Community/RichProfile/MyCustomList';
import MyListsRichProfile from 'pages/Community/RichProfile/MyLists';
import FollowersProfile from 'pages/Community/RichProfile/Profile/Followers';
import FollowingProfile from 'pages/Community/RichProfile/Profile/Following';
import ProfileRichProfile from 'pages/Community/RichProfile/Profile';
import PurchaseHistoryRichProfile from 'pages/Community/RichProfile/PurchaseHistory';
import ShoppingListRichProfile from 'pages/Community/RichProfile/ShoppingList';
import ContentContent from 'pages/Content/Content';
import EnhancedContentContent from 'pages/Content/EnhancedContent';
import TargetedLandingPageContent from 'pages/Content/TargetedLandingPage';
import BeautyWinPromoContentStore from 'pages/ContentStore/BeautyWinPromo';
import BrandLaunchContentStore from 'pages/ContentStore/BrandLaunch';
import ContactUsContentStore from 'pages/ContentStore/ContactUs';
import OrderStatusContentStore from 'pages/ContentStore/OrderStatus';
import RwdContentStoreContentStore from 'pages/ContentStore/RwdContentStore';
import CreatorStoreFrontCreatorStoreFront from 'pages/CreatorStoreFront/CreatorStoreFront';
import ApplyCreditCard from 'pages/CreditCard/Apply';
import CreditCardCreditCard from 'pages/CreditCard/CreditCard';
import NotFound404ErrorPages from 'pages/ErrorPages/NotFound404';
import GenericErrorHappening from 'pages/Happening/GenericError';
import HappeningHappening from 'pages/Happening/Happening';
import HappeningNonContentHappening from 'pages/Happening/HappeningNonContent';
import ShopMyStoreHappening from 'pages/Happening/ShopMyStore';
import ShopSameDayHappening from 'pages/Happening/ShopSameDay';
import InvoiceInvoice from 'pages/Invoice/Invoice';
import PreviewSettingsPreviewSettings from 'pages/PreviewSettings/PreviewSettings';
import AddReviewPageProduct from 'pages/Product/AddReviewPage';
import SubmitAnswerProduct from 'pages/Product/SubmitAnswer';
import SubmitQuestionProduct from 'pages/Product/SubmitQuestion';
import UnsubscribeQuestionProduct from 'pages/Product/UnsubscribeQuestion';
import RewardsRewards from 'pages/Rewards/Rewards';
import SamplesSamples from 'pages/Samples/Samples';
import DepartmentsSiteMap from 'pages/SiteMap/Departments';
import PhotoCaptureSmartSkinScan from 'pages/SmartSkinScan/PhotoCapture';
import SmartSkinScanSmartSkinScan from 'pages/SmartSkinScan/SmartSkinScan';
import CompleteStoreListStore from 'pages/Store/CompleteStoreList';
import StoreLocatorStore from 'pages/Store/StoreLocator';
import AffiliatesThirdParty from 'pages/ThirdParty/Affiliates';
import VendorGenericLoginThirdParty from 'pages/ThirdParty/VendorGenericLogin';
import VendorLoginThirdParty from 'pages/ThirdParty/VendorLogin';

const pages = {
    'BeautyPreferences/BeautyPreferences': BeautyPreferencesBeautyPreferences,
    'Brands/BrandsList': BrandsListBrands,
    'BuyPage/NewRwdBuyPage': NewRwdBuyPageBuyPage,
    'BuyPage/RwdBuyPage': RwdBuyPageBuyPage,
    'Checkout/Checkout': CheckoutCheckout,
    'Checkout/Confirmation': ConfirmationCheckout,
    'Checkout/FSCheckout': FSCheckoutCheckout,
    'Checkout/RwdCheckout': RwdCheckoutCheckout,
    'Community/Community': CommunityCommunity,
    'Community/Gallery/AddPhoto': AddPhotoGallery,
    'Community/Gallery/UsersPublicGallery': UsersPublicGalleryGallery,
    'Community/GalleryPage': GalleryPageCommunity,
    'Community/MyGallery': MyGalleryCommunity,
    'Community/RichProfile/BeautyInsider/MyPoints': MyPointsBeautyInsider,
    'Community/RichProfile/BeautyInsider': BeautyInsiderRichProfile,
    'Community/RichProfile/CreditCard': CreditCardRichProfile,
    'Community/RichProfile/InstoreServices': InstoreServicesRichProfile,
    'Community/RichProfile/Lists': ListsRichProfile,
    'Community/RichProfile/MyAccount/Addresses': AddressesMyAccount,
    'Community/RichProfile/MyAccount/AutoReplenishment': AutoReplenishmentMyAccount,
    'Community/RichProfile/MyAccount/CurbsidePickupCheckinModal/CurbsidePickupCheckinModalRouter': CurbsidePickupCheckinModalRouterCurbsidePickupCheckinModal,
    'Community/RichProfile/MyAccount/CurbsidePickupCheckinModal/VehicleColorSelector': VehicleColorSelectorCurbsidePickupCheckinModal,
    'Community/RichProfile/MyAccount/CurbsidePickupCheckinModal/screens/CurbsideNotAvailableScreen': CurbsideNotAvailableScreenscreens,
    'Community/RichProfile/MyAccount/CurbsidePickupCheckinModal/screens/CurbsidePickupBarcodeScreen': CurbsidePickupBarcodeScreenscreens,
    'Community/RichProfile/MyAccount/CurbsidePickupCheckinModal/screens/CurbsidePickupCheckinScreen': CurbsidePickupCheckinScreenscreens,
    'Community/RichProfile/MyAccount/CurbsidePickupCheckinModal/screens/CurbsidePickupLandingScreen': CurbsidePickupLandingScreenscreens,
    'Community/RichProfile/MyAccount/CurbsidePickupCheckinModal/screens/CurbsidePickupStoreClosedScreen': CurbsidePickupStoreClosedScreenscreens,
    'Community/RichProfile/MyAccount/EmailPostal': EmailPostalMyAccount,
    'Community/RichProfile/MyAccount/OrderDetails': OrderDetailsMyAccount,
    'Community/RichProfile/MyAccount/Orders': OrdersMyAccount,
    'Community/RichProfile/MyAccount/PaymentMethods': PaymentMethodsMyAccount,
    'Community/RichProfile/MyAccount/ReplacementOrder': ReplacementOrderMyAccount,
    'Community/RichProfile/MyAccount/ReplacementOrderStatus': ReplacementOrderStatusMyAccount,
    'Community/RichProfile/MyAccount/ResetPassword': ResetPasswordMyAccount,
    'Community/RichProfile/MyAccount/SameDayUnlimited': SameDayUnlimitedMyAccount,
    'Community/RichProfile/MyAccount/TaxClaim': TaxClaimMyAccount,
    'Community/RichProfile/MyAccount': MyAccountRichProfile,
    'Community/RichProfile/MyCustomList': MyCustomListRichProfile,
    'Community/RichProfile/MyLists': MyListsRichProfile,
    'Community/RichProfile/Profile/Followers': FollowersProfile,
    'Community/RichProfile/Profile/Following': FollowingProfile,
    'Community/RichProfile/Profile': ProfileRichProfile,
    'Community/RichProfile/PurchaseHistory': PurchaseHistoryRichProfile,
    'Community/RichProfile/ShoppingList': ShoppingListRichProfile,
    'Content/Content': ContentContent,
    'Content/EnhancedContent': EnhancedContentContent,
    'Content/TargetedLandingPage': TargetedLandingPageContent,
    'ContentStore/BeautyWinPromo': BeautyWinPromoContentStore,
    'ContentStore/BrandLaunch': BrandLaunchContentStore,
    'ContentStore/ContactUs': ContactUsContentStore,
    'ContentStore/OrderStatus': OrderStatusContentStore,
    'ContentStore/RwdContentStore': RwdContentStoreContentStore,
    'CreatorStoreFront/CreatorStoreFront': CreatorStoreFrontCreatorStoreFront,
    'CreditCard/Apply': ApplyCreditCard,
    'CreditCard/CreditCard': CreditCardCreditCard,
    'ErrorPages/NotFound404': NotFound404ErrorPages,
    'Happening/GenericError': GenericErrorHappening,
    'Happening/Happening': HappeningHappening,
    'Happening/HappeningNonContent': HappeningNonContentHappening,
    'Happening/ShopMyStore': ShopMyStoreHappening,
    'Happening/ShopSameDay': ShopSameDayHappening,
    'Invoice/Invoice': InvoiceInvoice,
    'PreviewSettings/PreviewSettings': PreviewSettingsPreviewSettings,
    'Product/AddReviewPage': AddReviewPageProduct,
    'Product/SubmitAnswer': SubmitAnswerProduct,
    'Product/SubmitQuestion': SubmitQuestionProduct,
    'Product/UnsubscribeQuestion': UnsubscribeQuestionProduct,
    'Rewards/Rewards': RewardsRewards,
    'Samples/Samples': SamplesSamples,
    'SiteMap/Departments': DepartmentsSiteMap,
    'SmartSkinScan/PhotoCapture': PhotoCaptureSmartSkinScan,
    'SmartSkinScan/SmartSkinScan': SmartSkinScanSmartSkinScan,
    'Store/CompleteStoreList': CompleteStoreListStore,
    'Store/StoreLocator': StoreLocatorStore,
    'ThirdParty/Affiliates': AffiliatesThirdParty,
    'ThirdParty/VendorGenericLogin': VendorGenericLoginThirdParty,
    'ThirdParty/VendorLogin': VendorLoginThirdParty
};

export default pages;
